import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import * as wActs from "../actions/website-actions";
import * as wConsts from "../consts/website-consts";
import SeoHeaders from "../components/seoheaders";
import RightBanners from "../components/rightbanners";
import Loading from "../components/loading";
class ResetPassword extends Component {

  componentDidMount() {
    this.props.dispatch({ type: wConsts.ACTION_SET_PAGETYPE, payload: "reset" });

    let id = ""; let cde = "";
    id = wActs.getParameterByName("id",window.location.href,"");
    cde = wActs.getParameterByName("code",window.location.href,"");
    let dis = false;
    if(!wActs.isNullOrEmpty(id) || !wActs.isNullOrEmpty(cde)) {
      dis=true;
    }
    if(dis) {
      this.props.dispatch({type: wConsts.RESET_CONFIRM_STATUS_NEW, payload: {Id: id, Code: cde}});
    }
  }
  getTranslation(key) {
    return this.props.WebPage.Translations[key];
  }

  handleResetSubmit(e) {
    e.preventDefault();
    //this.ConfirmId.value = this.Id.value;

    this.props.dispatch(wActs.SendResetPassword(this.Id.value))
  }
  handleResetConfirmation(e) {
    e.preventDefault();
    this.props.dispatch(wActs.SendResetPasswordConfirmation(this.ConfirmId.value, this.Code.value));
  }

  render() {

    if(!this.props.WebPage.PageLoaded) {
      return (
        <Loading/>
      );
    }

    let showBan = this.props.WebPage.Settings.ShowRightBanners;

    return (
      <div className="content-wrap">
        <SeoHeaders Position={"Top"}/>
        <form>
        <div className={`cell ${showBan ? "x9" : "x12"}`}>
          <div className="white-wrap the-content">
          <div className="section-content" className="center-page">
            {this.props.ResetRequest.Status.indexOf("CONFIRM") < 0 &&
              <div className="centered-content confirm-account-section">
                <p>{this.getTranslation("page.resetpassword.main")}</p>
                <div className="input-block">
                  <label>{this.getTranslation("page.email")}</label>
                  <input ref={(ref) => {this.Id = ref}}  type="text" id="id" name="" />
                </div>
                <div className="centered-content ">
                  {this.props.ResetRequest.Status !== wConsts.RESET_STATUS_PENDING &&
                  <input type="submit" onClick={(e) => this.handleResetSubmit(e)}  title="" value={this.getTranslation("page.submit")}/>
                  }
                  {this.props.ResetRequest.Status === wConsts.RESET_STATUS_PENDING &&
                  <img src={"/imgs/loader.gif"} width={"75"} height={"75"} alt={"loading..."} />
                  }
                </div>
                <div style={{height: "300px"}}></div>
              </div>
            }
            {this.props.ResetRequest.Status.indexOf("CONFIRM") >= 0 && this.props.ResetRequest.Status !== wConsts.RESET_CONFIRM_STATUS_SUCCESS &&
              <div className="centered-content confirm-account-section">
                <input type={"hidden"} value={this.props.ResetRequest.Response.ConfirmId} ref={(ref) => {this.ConfirmId = ref}} id={"ConfirmId"} name={"ConfirmId"}/>
                <p>{this.props.ResetRequest.Message}</p>
                <div className="input-block">
                  <label>Code</label>
                  <input ref={(ref) => {this.Code = ref}}  type="text" id="Code" name="" defaultValue={this.props.ResetRequest.Response.Code} />
                </div>

                <div className="centered-content ">
                  {this.props.ResetRequest.Status !== wConsts.RESET_CONFIRM_STATUS_PENDING &&
                  <input type="submit" onClick={(e) => {this.handleResetConfirmation(e)}} title="" value={this.getTranslation("page.submit")}/>
                  }
                  {this.props.ResetRequest.Status === wConsts.RESET_CONFIRM_STATUS_PENDING &&
                  <img src={"/imgs/loader.gif"} width={"75"} height={"75"} alt={"loading..."} />
                  }
                </div>
                <div style={{height: "300px"}}></div>
              </div>
            }
            {this.props.ResetRequest.Status === wConsts.RESET_CONFIRM_STATUS_SUCCESS &&
              <div className="centered-content confirm-account-section">
                <p>{this.props.ResetRequest.Message}</p>
                <div style={{height: "300px"}}></div>
              </div>
            }
          </div>
          </div>
        </div>
        </form>
        {showBan &&
        <div className="cell x3">
          <RightBanners/>
        </div>
        }
        <SeoHeaders Position={"Bottom"}/>

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    Content: state.Website.Page.Content,
    ResetRequest: state.Website.ResetPassword,
    WebPage: state.Website
  };
}

export default connect(mapStateToProps)(ResetPassword);
